import React from "react";
import { DebitListForCash } from "@icoach/batchPayment/component";
import { useBatchPaymentContext } from "@icoach/batchPayment/component/BatchPaymentContext";

/** ================================
 * 📌 免扣款名單
 *  ================================
 */
const MembershipBatchPaymentExemptedDebitList = () => {
	const { searchParams, batchPaymentLists, dialogRef, getBatchPayments } = useBatchPaymentContext();

	return <DebitListForCash list={batchPaymentLists?.noPaymentItems || []} dialogRef={dialogRef}
							 refresh={() => getBatchPayments(searchParams)} />;
};

export default MembershipBatchPaymentExemptedDebitList;
